import React from 'react';
import { Badge } from 'react-bootstrap';
import moment from 'moment';

/**
 * Componente para mostrar el estado de un ingreso
 * @param {Object} ingreso - Objeto con información del ingreso
 * @param {string} ingreso.estado - Estado del ingreso (Abierta, Cerrada, Anulado)
 * @param {Date} ingreso.fechaIngreso - Fecha de ingreso
 */
export const EstadoBadge = ({ ingreso }) => {
  const { estado, fechaIngreso } = ingreso;
  
  if (!estado) return null;

  // Calcular días desde el ingreso
  const diasDesdeIngreso = moment().diff(fechaIngreso, 'd');

  // Mapeo de estados y sus variantes
  const estadoConfig = {
    'Cerrada': {
      text: 'Cerrado',
      bg: 'success',
      className: 'cerrada'
    },
    'Anulado': {
      text: 'Anulado',
      bg: 'danger',
      className: 'atrasada'
    }
  };

  // Si está cerrada o anulada, retornar badge estático
  if (estadoConfig[estado]) {
    const config = estadoConfig[estado];
    return (
      <Badge 
        bg={config.bg} 
        className={`w-100 py-2 ${config.className}`}
        style={{ fontSize: '0.85rem' }}
      >
        {config.text}
      </Badge>
    );
  }

  // Para estado "Abierta", calcular el sub-estado basado en días
  if (estado === 'Abierta') {
    if (diasDesdeIngreso < 9) {
      return (
        <Badge 
          bg="success" 
          className="w-100 py-2 a-tiempo"
          style={{ fontSize: '0.85rem' }}
        >
          A tiempo
        </Badge>
      );
    } else if (diasDesdeIngreso === 12) {
      return (
        <Badge 
          bg="warning" 
          text="dark"
          className="w-100 py-2 Cierrahoy"
          style={{ fontSize: '0.85rem' }}
        >
          Cierra Hoy
        </Badge>
      );
    } else if (diasDesdeIngreso > 12) {
      return (
        <Badge 
          bg="danger" 
          className="w-100 py-2 atrasada"
          style={{ fontSize: '0.85rem' }}
        >
          Atrasado
        </Badge>
      );
    } else if (diasDesdeIngreso >= 9 && diasDesdeIngreso < 12) {
      return (
        <Badge 
          bg="warning" 
          text="dark"
          className="w-100 py-2 a-vencer"
          style={{ fontSize: '0.85rem' }}
        >
          Próximo a cerrar
        </Badge>
      );
    }
  }

  // Estado por defecto
  return (
    <Badge 
      bg="secondary" 
      className="w-100 py-2"
      style={{ fontSize: '0.85rem' }}
    >
      {estado}
    </Badge>
  );
};
